import { createStore } from "vuex";
import EventBus from "@/utils/EventBus";
import { getTokenExpiration } from "@/utils/tokenExpiration";

let expirationTimer = null;

function clearExpirationTimer() {
  if (expirationTimer !== null) window.clearTimeout(expirationTimer);
  expirationTimer = null;
}

function scheduleExpiration(store, expiresAt) {
  clearExpirationTimer();
  const delay = Math.min(Math.max(expiresAt - Date.now(), 0), 2_147_483_647);
  expirationTimer = window.setTimeout(() => {
    expirationTimer = null;
    store.commit("checkTokenExpiration");
  }, delay);
}

const store = createStore({
  state: {
    token: "",
    tokenExpireTime: 0,
  },
  mutations: {
    setToken(state, { token }) {
      // 与登录响应使用相同的 JWT exp，避免重新依赖无时区日期或旧缓存时间。
      const expiresAt = getTokenExpiration(token);
      if (!token || !Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
        store.commit("delToken");
        return;
      }
      state.token = token;
      state.tokenExpireTime = expiresAt;
      window.localStorage.setItem("token", token);
      window.localStorage.setItem("tokenExpireTime", String(expiresAt));
      scheduleExpiration(store, expiresAt);
    },
    delToken(state) {
      state.token = "";
      state.tokenExpireTime = 0;
      clearExpirationTimer();
      // 只清理认证数据，保留音乐音量、播放模式和其他用户偏好。
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("tokenExpireTime");
      window.localStorage.removeItem("user");
      EventBus.emit("auth-state-changed");
    },
    checkTokenExpiration(state) {
      // localStorage 是跨标签页共享来源，不能用旧 state.token 兜底复活已退出会话。
      const token = window.localStorage.getItem("token") || "";
      const expiresAt = getTokenExpiration(token);
      if (!token || !Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
        if (state.token || token || window.localStorage.getItem("user") || window.localStorage.getItem("tokenExpireTime")) {
          store.commit("delToken");
        }
        return;
      }
      const changed = state.token !== token || state.tokenExpireTime !== expiresAt;
      state.token = token;
      state.tokenExpireTime = expiresAt;
      if (window.localStorage.getItem("tokenExpireTime") !== String(expiresAt)) {
        window.localStorage.setItem("tokenExpireTime", String(expiresAt));
      }
      if (changed || expirationTimer === null) scheduleExpiration(store, expiresAt);
      if (changed) EventBus.emit("auth-state-changed");
    },
  },
  getters: {
    isTokenValid(state) {
      return Boolean(state.token && Number.isFinite(state.tokenExpireTime) && state.tokenExpireTime > Date.now());
    },
  },
});

store.commit("checkTokenExpiration");
window.setInterval(() => store.commit("checkTokenExpiration"), 60_000);
window.addEventListener("storage", (event) => {
  if (event.storageArea !== window.localStorage) return;
  if (event.key !== null && !["token", "tokenExpireTime", "user"].includes(event.key)) return;
  store.commit("checkTokenExpiration");
  // 头像/角色等资料变化也需要同步，事件本身不携带 token 或个人资料。
  EventBus.emit("auth-state-changed");
});
window.addEventListener("focus", () => store.commit("checkTokenExpiration"));
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") store.commit("checkTokenExpiration");
});

export default store;
